import { Uuid } from '@ftr/contracts/type/shared'
import { GoldSttContext, matchGoldSttContext } from './gold-stt-context'

/*
 * This is used by the Audio Order Playback Page.
 * We are listen to socket events based on the OrderId.
 * We query data based on the AudioSegmentId.
 */

export interface GoldAudioOrderSttContext {
  type: 'audio-order'
  orderId: Uuid
  audioSegmentId: Uuid
}

export function buildGoldAudioOrderSttContext(orderId: Uuid, audioSegmentId: Uuid): GoldAudioOrderSttContext {
  return {
    type: 'audio-order',
    orderId,
    audioSegmentId,
  }
}

export const goldAudioOrderSttContextEquals =
  (other: GoldSttContext) =>
  (self: GoldAudioOrderSttContext): boolean =>
    matchGoldSttContext(other, {
      mapAudioOrder: ({ orderId }) => orderId === self.orderId,
      mapRecording: () => false,
      mapSharedRecording: () => false,
    })
